import React, { useState } from 'react';
import { Share2, Link2, Check } from 'lucide-react';

const SHARE_URL = typeof window !== 'undefined' ? window.location.origin : '';
const SHARE_TEXT = 'Compara y cotiza tu seguro de viaje con IwannaInsurance. ¡Usa el código WELCOME10 para 10% de descuento!';

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" className="h-5 w-5 fill-current" aria-hidden="true" {...props}>
    <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.5 1.9 6.4L4 29l7.9-2c1.3.5 2.7.7 4.1.7 6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.8c-1.3 0-2.6-.3-3.7-.8l-.3-.1-4.1 1.1 1.1-3.9-.2-.3c-1.1-1.6-1.7-3.5-1.7-5.4C7.1 9.6 11.1 5.7 16 5.7s8.9 3.9 8.9 8.7c0 4.8-4 8.7-8.9 8.7zm5-6.4c-.3-.1-1.6-.8-1.9-.9-.3-.1-.4-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.1-.4-2.2-1.3-.8-.7-1.4-1.6-1.5-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.4-.8-2-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s1 2.5 1.1 2.7c.1.2 1.9 2.9 4.6 4 .6.3 1.1.4 1.5.6.6.2 1.2.2 1.7.1.5-.1 1.6-.6 1.8-1.3.2-.6.2-1.1.2-1.3-.1-.1-.3-.2-.5-.3z" />
  </svg>
);
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true"><path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.41 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07z" /></svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden="true"><path d="M12 2.16c3.2 0 3.58 0 4.85.07 3.25.15 4.77 1.69 4.92 4.92.06 1.27.07 1.65.07 4.85s0 3.58-.07 4.85c-.15 3.23-1.66 4.77-4.92 4.92-1.27.06-1.64.07-4.85.07s-3.58 0-4.85-.07c-3.26-.15-4.77-1.7-4.92-4.92C2.17 15.58 2.16 15.2 2.16 12s0-3.58.07-4.85C2.38 3.92 3.9 2.38 7.15 2.23 8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 2.7.27.27 2.69.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.2 4.36 2.62 6.78 6.98 6.98C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c4.35-.2 6.78-2.62 6.98-6.98.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.2-4.35-2.62-6.78-6.98-6.98C15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1 0 12 18.16 6.16 6.16 0 0 0 12 5.84zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z" /></svg>
);

export const ShareButtons = ({ variant = 'light', onShare, url, text }) => {
  const [copied, setCopied] = useState(false);
  const dark = variant === 'dark';
  const shareUrl = url || SHARE_URL;
  const shareText = text || SHARE_TEXT;
  const base = `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-[background-color,transform] duration-200 hover:scale-105 ${dark ? 'bg-white/10 text-white hover:bg-white/20' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`;

  const share = (network, target) => {
    onShare?.(network);
    window.open(target, '_blank', 'noopener,noreferrer,width=640,height=560');
  };

  const copyLink = async () => {
    onShare?.('Instagram');
    try {
      await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = `${shareText} ${shareUrl}`;
      document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`share-buttons-${variant}`}>
      <span className={`inline-flex items-center gap-1.5 text-sm mr-1 ${dark ? 'text-white/70' : 'text-slate-500'}`}><Share2 className="h-4 w-4" /> Compartir:</span>
      <button type="button" data-testid={`share-whatsapp-${variant}`} onClick={() => share('WhatsApp', `https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`)} className={`${base} hover:!bg-[#25D366] hover:!text-white`}>
        <WhatsAppIcon /> WhatsApp
      </button>
      <button type="button" data-testid={`share-facebook-${variant}`} onClick={() => share('Facebook', `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`)} className={`${base} hover:!bg-[#1877F2] hover:!text-white`}>
        <FacebookIcon /> Facebook
      </button>
      <button type="button" data-testid={`share-instagram-${variant}`} onClick={copyLink} className={`${base} hover:!bg-gradient-to-r hover:!from-[#f58529] hover:!via-[#dd2a7b] hover:!to-[#8134af] hover:!text-white`} title="Copia el enlace para pegarlo en tu historia o bio de Instagram">
        {copied ? <Check className="h-5 w-5" /> : <InstagramIcon />} {copied ? '¡Enlace copiado!' : 'Instagram'}
      </button>
      <button type="button" data-testid={`share-copy-${variant}`} onClick={copyLink} aria-label="Copiar enlace" className={`${base} !px-2.5`}>
        <Link2 className="h-4 w-4" />
      </button>
    </div>
  );
};

export default ShareButtons;
